import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { AlertTriangle, ShieldCheck, ShieldAlert } from "lucide-react";
import api from "@/lib/api";
import { useI18n } from "@/i18n";

export function ValidatorChips() {
  const { t } = useI18n();
  const { data } = useQuery({ queryKey: ["einvoice-health"], queryFn: async () => (await api.get("/einvoice/health")).data });
  if (!data) return null;
  const v = data.validator, z = data.zugferd_generation;
  const chip = (ok, label, hint) => (
    <span data-testid={`chip-${label}`} title={hint || ""}
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium ${ok ? "bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300" : "bg-amber-100 text-amber-800 dark:bg-amber-950 dark:text-amber-300"}`}>
      {ok ? <ShieldCheck className="h-3 w-3" /> : <ShieldAlert className="h-3 w-3" />}{label}
    </span>
  );
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="validator-chips">
      {chip(v.status === "configured", `KoSIT ${v.status === "configured" ? "✓" : "—"}`, v.bundle || v.reason)}
      {chip(z.status === "configured", `ZUGFeRD ${z.status === "configured" ? "✓" : "—"}`, z.engine || z.reason)}
    </div>
  );
}

export function SetupBanner() {
  const { t } = useI18n();
  const { data } = useQuery({ queryKey: ["einvoice-readiness"], queryFn: async () => (await api.get("/einvoice/readiness")).data });
  if (!data || data.ready) return null;
  return (
    <div data-testid="einvoice-setup-banner"
      className="mb-4 flex flex-col gap-2 rounded-lg border border-amber-300 bg-amber-50 p-4 text-sm text-amber-900 dark:border-amber-800 dark:bg-amber-950/40 dark:text-amber-200 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-start gap-2">
        <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />
        <div>
          <p className="font-semibold">{t("einvoice.setup_incomplete")}</p>
          <p className="mt-0.5">{data.missing.map((m) => t(`einvoice.missing.${m}`)).join(" · ")}</p>
        </div>
      </div>
      <Link to="/settings" data-testid="einvoice-setup-link"
        className="shrink-0 rounded-md bg-amber-600 px-3 py-1.5 font-medium text-white hover:bg-amber-700">
        {t("einvoice.complete_setup")}
      </Link>
    </div>
  );
}
